import { z } from 'zod';

import { apiClient } from '@/lib/api-client';
import {
  bookmarkResultSchema,
  commentListSchema,
  commentPageSchema,
  commentSchema,
  voteResultSchema,
  type Comment,
  type CommentPage,
  type VoteResult,
} from '@/lib/schemas/comment';
import { postListSchema, type Post } from '@/lib/schemas/post';

export const interactionApi = {
  upvotePost: (postId: string): Promise<VoteResult> =>
    apiClient.post(`/posts/${postId}/vote`, voteResultSchema),
  removePostUpvote: (postId: string): Promise<VoteResult> =>
    apiClient.delete(`/posts/${postId}/vote`, voteResultSchema),

  upvoteComment: (commentId: string): Promise<VoteResult> =>
    apiClient.post(`/comments/${commentId}/vote`, voteResultSchema),
  removeCommentUpvote: (commentId: string): Promise<VoteResult> =>
    apiClient.delete(`/comments/${commentId}/vote`, voteResultSchema),

  bookmark: (postId: string) => apiClient.post(`/posts/${postId}/bookmark`, bookmarkResultSchema),
  removeBookmark: (postId: string) =>
    apiClient.delete(`/posts/${postId}/bookmark`, bookmarkResultSchema),

  listBookmarks: (signal?: AbortSignal): Promise<Post[]> =>
    apiClient.get('/users/me/bookmarks', postListSchema, signal ? { signal } : {}),

  listComments: (postId: string, cursor?: string, signal?: AbortSignal): Promise<CommentPage> =>
    apiClient.get(`/posts/${postId}/comments`, commentPageSchema, {
      ...(cursor ? { query: { cursor } } : {}),
      ...(signal ? { signal } : {}),
    }),

  listReplies: (commentId: string, signal?: AbortSignal) =>
    apiClient.get(`/comments/${commentId}/replies`, commentListSchema, signal ? { signal } : {}),

  createComment: (postId: string, body: string, parentId?: string): Promise<Comment> =>
    apiClient.post(`/posts/${postId}/comments`, commentSchema, {
      body: { body, ...(parentId ? { parentId } : {}) },
    }),

  updateComment: (commentId: string, body: string): Promise<Comment> =>
    apiClient.patch(`/comments/${commentId}`, commentSchema, { body: { body } }),

  deleteComment: (commentId: string): Promise<null> =>
    apiClient.delete(`/comments/${commentId}`, z.null()),
};
